// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"80e3a936","144":"33c4e49b","149":"17ec2fa0","693":"8a7d8fdd","887":"1a9950bb"}[chunkId] + ".chunk.js";
};